import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

const BASE = { video: "/videos/nuvlipro-hero-v2.mp4", poster: "/videos/nuvlipro-hero-v2-poster.jpg" };
// Vídeo por idioma (p. ej. en: { video, poster }); los idiomas sin entrada usan BASE.
const VIDEOS = { es: BASE };
const PAUSA_MS = 15000;

export function HeroVideo({ badge, tituloA, tituloB }) {
  const ref = useRef(null);
  const { i18n } = useTranslation();
  const { video, poster } = VIDEOS[(i18n.resolvedLanguage || i18n.language || "es").split("-")[0]] || BASE;
  // iOS solo lo reproduce automáticamente si también lleva el atributo muted.
  // Al terminar se queda en el último fotograma 15 s y vuelve a empezar.
  useEffect(() => {
    const v = ref.current;
    if (!v) return;
    let espera;
    const alTerminar = () => {
      espera = setTimeout(() => { v.currentTime = 0; v.play().catch(() => {}); }, PAUSA_MS);
    };
    v.muted = true;
    v.setAttribute("muted", "");
    v.addEventListener("ended", alTerminar);
    v.play().catch(() => {});
    return () => { clearTimeout(espera); v.removeEventListener("ended", alTerminar); };
  }, [video]);
  return (
    <div className="relative bg-white px-4 pt-6 sm:pt-8 text-center" data-testid="hero-video-wrap">
      <span className="font-heading inline-block max-w-full mb-4 px-3 sm:px-4 py-1 sm:py-1.5 rounded-full bg-white/70 border border-sky-200/70 backdrop-blur-md shadow-sm text-[#034694] text-[9px] sm:text-xs font-semibold tracking-normal sm:tracking-wide uppercase animate-in fade-in-0 slide-in-from-top-2 duration-700" data-testid="hero-badge">
        {badge}
      </span>
      <video key={video} ref={ref} src={video} poster={poster} autoPlay muted playsInline preload="auto" disablePictureInPicture disableRemotePlayback
        aria-hidden="true" tabIndex={-1}
        className="block mx-auto w-auto h-auto max-w-full max-h-[60vh] pointer-events-none select-none" data-testid="hero-video" />
      <h1 className="font-heading max-w-5xl mx-auto mt-5 text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight text-[#1B2B4B] animate-in fade-in-0 slide-in-from-bottom-3 duration-700" data-testid="hero-title">
        {tituloA} <span className="text-[#00B4CC]">{tituloB}</span>
      </h1>
      <div className="absolute inset-x-0 top-full h-16 bg-gradient-to-b from-white to-transparent pointer-events-none" />
    </div>
  );
}
